/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import { postLearnArticle } from '../../Util/ApiService';
import { displayToast } from '../../Util/Toast';
import ArticleAdminModal from '../../Components/LearnArticleDataAdmin/Modal';

const LearnArticleDataAdminModal = ({
    addLearnArticleUri = '',
    updateLearnArticleUri = '',
    preFetchedArticle = {},
    type = 'edit',
    isAllSiteSelected = false,
    sites = [],
    languages = [],
    sections = [],
    subsections = [],
}) => {
    const [posting, setPosting] = useState(false);

    const postArticle = async (
        logo,
        title,
        languageCode,
        section,
        subsectionId,
        authorName,
        publisherName,
        publisherUrl,
        readingTime,
        active,
        selectedSites
    ) => {
        setPosting(true);
        const formData = new FormData();

        if (typeof logo === 'string') {
            formData.append('logoUpdated', false);
        } else {
            if (logo instanceof File) {
                formData.append('logo', logo, logo.name);
            }
            formData.append('logoUpdated', true);
        }
        if (title) formData.append('title', title);
        if (languageCode) formData.append('languageCode', languageCode);
        if (section) formData.append('learnSectionCode', section);
        if (subsectionId) formData.append('learnSubsectionId', parseInt(subsectionId, 10));
        if (authorName) formData.append('authorName', authorName);
        if (publisherName) formData.append('publisherName', publisherName);
        if (publisherUrl) formData.append('publisherUrl', publisherUrl);
        if (readingTime !== '' && readingTime !== null && readingTime !== undefined) {
            formData.append('readingTime', parseInt(readingTime, 10));
        }
        formData.append('active', active ? 1 : 0);
        if (Array.isArray(selectedSites)) {
            formData.append('sitesCodes', JSON.stringify(selectedSites));
        }

        try {
            if (type === 'add') {
                await postLearnArticle(addLearnArticleUri, formData);
                displayToast('Article created', 'success');
                // eslint-disable-next-line no-restricted-globals, no-undef
                return location.reload();
            } else {
                await postLearnArticle(updateLearnArticleUri, formData);
                displayToast('Article updated', 'success');
                // eslint-disable-next-line no-restricted-globals, no-undef
                return location.reload();
            }
        } catch (e) {
            setPosting(false);
            displayToast('Error submitting article', 'error');
        }
    };

    return (
        <ArticleAdminModal
            type={type}
            postArticle={postArticle}
            posting={posting}
            preFetchedArticle={preFetchedArticle}
            isAllSiteSelected={isAllSiteSelected}
            sites={sites}
            languages={languages}
            sections={sections}
            subsections={subsections}
        />
    );
};

export default LearnArticleDataAdminModal;

LearnArticleDataAdminModal.propTypes = {
    addLearnArticleUri: PropTypes.string,
    updateLearnArticleUri: PropTypes.string,
    preFetchedArticle: PropTypes.string,
    type: PropTypes.oneOf(['add', 'edit']),
    isAllSiteSelected: PropTypes.bool,
    sites: PropTypes.string,
    languages: PropTypes.string,
    sections: PropTypes.string,
    subsections: PropTypes.string,
};
